import React from 'react';
import {Thead, type TableHeadProps} from '@tempo/core';
import {useTableContext} from '@components/Table';
import {useTableStyles} from '../contexts/TableStyleContext';

const TableHeader = (props: TableHeadProps) => {
	const {stickyHeader} = useTableContext();
	const recipe = useTableStyles();

	return (
		<Thead
			{...props}
			sx={{
				...recipe.thead,
				...(stickyHeader
					? {
							'& > tr > th': {
								position: 'sticky',
								top: 0,
								zIndex: 'sticky',
							},
						}
					: {}),
				...props.sx,
			}}
		/>
	);
};

export default TableHeader;
